import { Alert, Stack, Typography } from "@mui/material"
import Input from "../Inputs/Pin"
import { LoadingButton } from "@mui/lab"

export default function Verify({data, onChange, onSubmit, error, loading, onPrevious}){

    return <form onSubmit={onSubmit}>
        
        <Stack spacing={2} sx={{maxWidth: 500, margin: 'auto'}}>

            <Typography>
                Un code permettant de vérifier votre identité vous a été envoyé par email à l'adresse <b>{data.email}</b>
            </Typography>

            <Typography>
                Veuillez le renseigner ci-dessous :
            </Typography>

            <Input
                value={data.pin}
                onChange={e => onChange({...data, pin: e.target.value})}
                error={error && "Code incorrect"}
            />


            <LoadingButton
                type='submit' 
                variant='contained'
                loading={loading}
            >
                Valider
            </LoadingButton>

            <Alert severity='info'>
                Vous n'avez pas reçu d'email ? Nous vous invitons à vérifier votre dossier de spams ou courriers indésirables.
            </Alert>


        </Stack>

    </form>
}